import { Routes } from 'react-router-dom';
import { getRoutes } from 'utils/get-routes-utils';
import { authenticationRoutes } from 'routes/authentication-routes';

const Main = () => {
  return (
    <div className="dashboard-wrapper">
      <Routes>{getRoutes(authenticationRoutes)}</Routes>
    </div>
  );
};
export default Main;
